import { render, staticRenderFns } from "./textarea-field.vue?vue&type=template&id=71b1312a"
import script from "./textarea-field.vue?vue&type=script&lang=js"
export * from "./textarea-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports